import { Text } from '@/components/atoms/Text';
import { cn } from '@/lib/utils';
import React from 'react';

export type MembersCarouselItemProps = {
  isActive?: boolean;

  name: string;
  jobTitle: string;
  description?: React.ReactNode;
  image?: React.ReactNode;
  classNames?: {
    root?: string;
    name?: string;
    jobTitle?: string;
    image?: string;
  };
};

export const MembersCarouselItem = React.forwardRef<
  HTMLDivElement,
  MembersCarouselItemProps
>(({ isActive, name, jobTitle, image, description, classNames }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'md:grid md:grid-cols-2 w-full px-1 md:px-0 items-center md:gap-5 xl:gap-40',
        classNames?.root
      )}
      tabIndex={isActive ? 0 : -1}
    >
      <div
        className={cn(
          'w-full h-full pb-8 md:pb-0 flex md:justify-end lg:pr-10',
          classNames?.image
        )}
      >
        {image}
      </div>
      <div className='gap-2 text-left lg:pr-[6rem] pb-2'>
        <Text
          classNames={{
            wrapper: cn('text-h3 font-serif', classNames?.name),
          }}
        >
          {name}
        </Text>
        <Text
          classNames={{
            wrapper: cn(
              'text-body-l text-gray-500 pb-6 font-mono',
              classNames?.jobTitle
            ),
          }}
        >
          {jobTitle}
        </Text>
        <div className='font-mono text-body-l pb-16 md:pb-0 text-gray-950'>
          {description}
        </div>
      </div>
    </div>
  );
});
